export const isFieldRejected = (rejectedData, section, field) => {
  return rejectedData?.[section]?.rejected_fields?.includes(field);
};

export const formatDateTimeUTC = (utcDate) => {
  if (!utcDate) return '-';

  const date = new Date(utcDate);

  const parts = new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(date);

  const values = Object.fromEntries(
    parts.map(({ type, value }) => [type, value]),
  );

  return `${values.day}/${values.month}/${values.year} ${values.hour}:${values.minute}`;
};
